export const SUBMISSION_LINK = [
  { title: "도메인 주소", detail: "과제의 도메인 주소를 제출", type: "url" },
  {
    title: "깃 리파지토리 주소",
    detail: "과제의 리파지토리 주소를 제출",
    type: "url",
  },
  {
    title: "프론트 리파지토리 주소",
    detail: "과제의 프론트 리파지토리 주소를 제출",
    type: "url",
  },
  {
    title: "백엔드 리파지토리 주소",
    detail: "과제의 백엔드 리파지토리 주소를 제출",
    type: "url",
  },
  {
    title: "이미지",
    detail: "이미지 화면을 캡쳐해서 제출",
    type: "image",
  },
  { title: "과제 주소", detail: "과제 주소를 제출", type: "url" },
];
